import { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const navState = useMemo(
    () => ({ from: location.pathname }),
    [location.pathname],
  );

  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-slate-50"
        data-testid="admin-loading"
      >
        <div className="text-slate-500 text-sm">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={navState} />;
  }

  if ((user.role || "").toLowerCase() !== "admin") {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-slate-50 px-6"
        data-testid="admin-forbidden"
      >
        <div className="max-w-md text-center">
          <div className="text-xs font-medium uppercase tracking-[0.18em] text-rose-600">
            403 — Forbidden
          </div>
          <h1 className="mt-3 text-3xl font-medium text-slate-900 tracking-tight">
            Admins only
          </h1>
          <p className="mt-3 text-slate-600">
            Your account doesn&apos;t have admin privileges. If you think this is a mistake,
            contact your account owner.
          </p>
          <a
            href="/dashboard"
            className="mt-6 inline-flex items-center rounded-xl bg-slate-900 px-5 py-2.5 text-sm font-medium text-white shadow-md hover:bg-slate-800 transition-all"
            data-testid="admin-forbidden-home-link"
          >
            Back to my dashboard
          </a>
        </div>
      </div>
    );
  }

  return children;
}
